import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { ILoginResponse } from '../../../services/auth/types';
import { login } from '../../../services/auth';
import { ILoginFormInitialValues } from '../../../pages/Login/form';

interface IProps {
  payload: ILoginFormInitialValues;
}

export const ThunkLogin = createAsyncThunk<ILoginResponse, IProps>(
  `${storeResources.AUTH}/login`,
  ({ payload }: IProps) => login(payload).then(res => res.data),
);

export default {};
